export default "__VITE_ASSET__CbT$XV$r__"